import React, { Component } from 'react'
import axios from "axios";
import Header from './Header';
import Footer from './Footer';


export class Client extends Component {
    constructor(props) {    
        super(props);    
        this.state = {    
            name: "",
            students:"",
        formErrors: {}    
        };    
        this.initialState = this.state;    
    }

    componentDidMount() {
        this.getClientList();
        //loadCaptchaEnginge(6); 
      } 
    // "http://localhost/webservices/getSchoolList.php"
    async getClientList() {
        axios.get(
            "https://schooleasyerp.com/webservices/getSchoolList.php"
            //"http://localhost/webservices/getSchoolList.php"
            ).then((response) => {
          //console.log(response.data); 
            if (response.status === 200) {
            this.setState({
                students: response.data ? response.data.result : [],
            });
            }
            //console.log(this.state.students);
            if (
            response.data.status === "failed" &&
            response.data.success === false
            ) {
            this.setState({
                noDataFound: response.data.message,
            });
            }
        });
        }


    render() {
        let studentsDetails =[];
        let s_no = 1;
        //console.log(students);
        let students = this.state.students;
        //console.log(students.length);
        if (students.length) {
            studentsDetails = students.map((student) => {
                
             /* return (
                <div className="slide"><img src={'https://stagingschool.myrkcl.com/upload/'+student.school_logo}/></div>
                
              );*/
              return (
                <div class="row">
                    <div class="col-md-2">{s_no++}</div>
                    <div class="col-md-8">{student.school_name}</div>				
                  
                    <div class="col-md-2">{student.school_city}</div>
                    
                </div>
              );
            });
          }
        
        
        return (
            <div>
      	    <Header/>
              <div class="container pb-5">
                    <section class="guest_opinion pt-5">
                        <h3 class="text-center pb-4 font-weight-bold title">Client List</h3>
                        <div class="row">
                            <div class="col-md-2"><strong>S.No.</strong></div>
                            <div class="col-md-8"><strong>SchoolEasy Active Clients</strong></div>				
                            
                            <div class="col-md-2"><strong>District/State</strong></div>
                            
                        </div>
                        {studentsDetails}
                        
                    </section>
                </div>


                <Footer />

            </div>
        )
    }
}

export default Client
